<!--
 * @Description: 转签约
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-13 10:36:55
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-form ref="formRef" name="advanced_search" :model="form">
        <dc-layout-card :title="t('custom.turnToDealTitle')" :span="12">
          <template #subTitle>
            <a-button type="primary" @click="hanleAdd" ghost>{{ t('btn.add') }}</a-button>
          </template>
          <template v-for="(item, index) in form.saleChance" :key="index">
            <div class="cos-form-line" v-if="index"></div>
            <dc-form-item
              :label="t('custom.arkCode')"
              :span="12"
              :name="['saleChance', index, 'arkCodeId']"
              :rules="{
                message: t('common.pleaseSelect'),
                required: true
              }"
            >
              <GcCodeSelect
                v-model:label="item.arkCode"
                v-model:value="item.arkCodeId"
                :stage="[3, 4]"
                appId="cos_ofbu"
                :cosId="route.query.cosId"
                :requiredCosId="true"
              />
            </dc-form-item>
            <dc-form-item
              :label="t('custom.chanceName')"
              :span="12"
              :name="['saleChance', index, 'chanceId']"
              :rules="{
                message: t('common.pleaseInput'),
                required: true
              }"
            >
              <businessSelect
                v-model:value="item.chanceId"
                :arkCodeId="item.arkCodeId"
                :statusList="[1, 2, 4]"
                appId="cos_ofbu"
                :saleChanceRefId="route.query.cosId"
              />
            </dc-form-item>
            <dc-form-item
              :label="t('custom.firstOrderId')"
              :span="12"
              :name="['saleChance', index, 'firstOrderId']"
              :rules="{
                message: t('common.pleaseSelect'),
                required: true
              }"
            >
              <a-input v-model:value="item.firstOrderId" :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item
              :label="t('custom.firstOrderTime')"
              :span="12"
              :name="['saleChance', index, 'firstOrderTime']"
              :rules="{
                message: t('common.pleaseSelect'),
                required: true
              }"
            >
              <div class="flex">
                <CosDatePicker v-model:value="item.firstOrderTime" isOutputBeijingTime :showTime="true" />
                <a-button
                  type="text"
                  danger
                  style="padding-right: 0px"
                  @click="hanleDel(index)"
                  v-show="form.saleChance && form.saleChance.length > 1"
                  >{{ t('btn.del') }}</a-button
                >
              </div>
            </dc-form-item>
          </template>
        </dc-layout-card>
      </a-form>
      <cos-footer-button
        v-model:value="form"
        :formRef="formRef"
        :permissionPage="permissionBasic"
        :resetValue="resetValue"
        :disabled="false"
        @submit="handleSubmit"
      ></cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { turnTransaction } from '@/api/overseasSales/customerCenter'
import GcCodeSelect from '@/components/GcCodeSelect'
import BusinessSelect from '@/components/BusinessSelect'
import { useRoute, useRouter } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import CosDatePicker from '@/components/CosDatePicker/index'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const formRef = ref()
const form = ref<{
  saleChance: {
    arkCode?: string
    contractCode?: string
    saleChanceubject?: string
    serviceSubject?: number
    cosId?: any
  }[]
}>({
  saleChance: [{}]
})
const permissionBasic = {
  save: 'ofbu_contract_deal_btn'
}
const resetValue = ref({
  saleChance: [{}]
})
const hanleAdd = () => {
  form.value.saleChance.push({})
}
const hanleDel = (index: number) => {
  form.value.saleChance.splice(index, 1)
}
const handleSubmit = () => {
  form.value.saleChance.forEach((item) => (item.cosId = route.query.cosId))
  turnTransaction(form.value.saleChance).then((res) => {
    layoutTags.close()
    message.success(t('tips.activitySuccess'))
    router.push({
      path: '/ofbu/contract'
    })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuTurnToDeal' }
</script>
